// extracted by mini-css-extract-plugin
export default {"loginPage":"Login_loginPage__ElMxB","loginFormLayout":"Login_loginFormLayout__SITOD"};